const GlobalPageLayout = ({ header = null, footer = null, children }) => {
  return (
    <>
      {header}
      <main id="main-content" tabIndex="-1">
        {children}
      </main>
      {footer}
    </>
  )
}

export default GlobalPageLayout
